// src/navigations/path.jsx - Centralized route paths

// Dashboard
export const DASHBOARD_PATH = '/dashboard';

// Merchant Routes
export const CREATE_MERCHANT = '/create-merchant';
export const IN_UNDERWRITING_PATH = '/in-underwriting';
export const MERCHANT_ACCOUNTS_LIST = '/merchants/accounts';
export const PENDING_PATH = '/pending';
export const COMPLETE_PATH = '/complete';

// User Management Routes
export const USERS_LIST_PATH = '/users-list';
export const TEAMS_LISTS_PATH = '/teams-lists';
export const CREATE_TEAM = '/create-team';
export const CREATE_USER = '/create-user';

// Customer Management Routes
export const CUSTOMERS_LIST_PATH = '/customers';
export const CUSTOMERS_CREATE_PATH = '/customers/create';
export const CUSTOMERS_EDIT_PATH = '/customers/edit';
export const CUSTOMERS_VIEW_PATH = '/customers/view';

// Sales DBA
export const SALES_DBA_LISTING = '/sales-dba';

// Profile
export const PROFILE_PATH = '/profile';
export const Profile_page = '/profile';

// Notifications
export const NOTIFICATIONS_PATH = '/notifications';

// Leads Routes
export const LEADS_PATH = '/leads';
export const LEADS_CREATE_PATH = '/leads/create';
export const LEADS_UPLOAD_DOCUMENTS_PATH = '/leads/:id/upload-documents';
export const leadUploadDocumentsPath = (id) => `/leads/${id}/upload-documents`;

// Permissions
export const ROLE_PERMISSION = '/permission/role';
export const USER_PERMISSION = '/permissions/assign';

// Roles
export const ROLES_LIST_PATH = '/roles';
export const ROLES_CREATE_PATH = '/roles/create';
export const ROLES_EDIT_PATH = '/roles/edit';

// Statuses
export const STATUSES_LIST_PATH = '/statuses';
export const STATUSES_CREATE_PATH = '/statuses/create';

// Issues
export const ISSUE_LIST_PAGE = '/issues';

// Contracts
export const CONTRACTS_LIST_PATH = '/contracts';

// Daily Summary
export const DAILY_SUMMARY_LIST_PATH = '/daily-summary';
export const DAILY_SUMMARY_CREATE_PATH = '/daily-summary/create';
export const DAILY_SUMMARY_VIEW_PATH = '/daily-summary/view';

// Calls Counter Summary
export const CALLS_COUNTER_SUMMARY_PATH = '/calls-counter-summary';

// Leads Report
export const LEADS_REPORT_PATH = '/leads-report';

// Call recordings
export const CALL_RECORDS_LIST_PATH = '/call-records';
export const CALL_RECORDS_CREATE_PATH = '/call-records/create';
export const CALL_RECORDS_VIEW_PATH = '/call-records/view';
export const CALL_RECORDS_EDIT_PATH = '/call-records/edit';

// Recent Activities (Reports)
export const RECENT_ACTIVITIES_REPORT_PATH = '/reports/recent-activities';

// Calendar / Meetings
export const CALENDAR_SCHEDULE_PATH = '/meetings/calendar';
export const MEETING_CREATE_PATH = '/meetings/create';
export const MEETING_EDIT_PATH = '/meetings/edit';
export const MEETING_VIEW_PATH = '/meetings/view';




// Invoices
export const INVOICES_LIST_PATH = '/invoices';
export const INVOICES_CREATE_PATH = '/invoices/create';
export const INVOICES_EDIT_PATH = '/invoices/edit';
export const INVOICES_VIEW_PATH = '/invoices/view';

// Payments
export const PAYMENTS_LIST_PATH = '/payments';
export const PAYMENTS_VIEW_PATH = '/payments/view';

// Payment errors
export const PAYMENT_ERRORS_LIST_PATH = '/payment-errors';
export const PAYMENT_ERRORS_VIEW_PATH = '/payment-errors/view';

// Brands
export const BRANDS_LIST_PATH = '/brands';
export const BRANDS_CREATE_PATH = '/brands/create';
export const BRANDS_VIEW_PATH = '/brands/view';

// Services
export const SERVICES_LIST_PATH = '/services';
export const SERVICES_CREATE_PATH = '/services/create';
export const SERVICES_VIEW_PATH = '/services/view';

// Leases
export const LEASES_LIST_PATH = '/leases';
export const LEASES_CREATE_PATH = '/leases/create';
export const LEASES_VIEW_PATH = '/leases/view';

// Merchant service providers
export const MERCHANT_SERVICE_PROVIDERS_LIST_PATH = '/merchant-service-providers';
export const MERCHANT_SERVICE_PROVIDERS_CREATE_PATH = '/merchant-service-providers/create';
export const MERCHANT_SERVICE_PROVIDERS_VIEW_PATH = '/merchant-service-providers/view';

// Equipment models
export const EQUIPMENT_MODELS_LIST_PATH = '/equipment-models';
export const EQUIPMENT_MODELS_CREATE_PATH = '/equipment-models/create';
export const EQUIPMENT_MODELS_VIEW_PATH = '/equipment-models/view';

// Companies
export const COMPANIES_LIST_PATH = '/companies';
export const COMPANIES_CREATE_PATH = '/companies/create';
export const COMPANIES_VIEW_PATH = '/companies/view';

// Task types
export const TASK_TYPES_LIST_PATH = '/task-types';
export const TASK_TYPES_CREATE_PATH = '/task-types/create';
export const TASK_TYPES_VIEW_PATH = '/task-types/view';

// Task categories
export const TASK_CATEGORIES_LIST_PATH = '/task-categories';
export const TASK_CATEGORIES_CREATE_PATH = '/task-categories/create';
export const TASK_CATEGORIES_VIEW_PATH = '/task-categories/view';

// Task templates
export const TASK_TEMPLATES_LIST_PATH = '/task-templates';
export const TASK_TEMPLATES_CREATE_PATH = '/task-templates/create';
export const TASK_TEMPLATES_VIEW_PATH = '/task-templates/view';

// Tasks
export const TASKS_LIST_PATH = '/tasks';
export const TASKS_CREATE_PATH = '/tasks/create';
export const TASKS_VIEW_PATH = '/tasks/view';

// Lead quizzes
export const LEAD_QUIZZES_LIST_PATH = '/lead-quizzes';
export const LEAD_QUIZZES_CREATE_PATH = '/lead-quizzes/create';
export const LEAD_QUIZZES_VIEW_PATH = '/lead-quizzes/view';

// Data (formerly Import Businesses)
export const IMPORT_BUSINESSES_LIST_PATH = '/data';
export const IMPORT_BUSINESSES_VIEW_PATH = '/data/view';
